<div class="container py-5 bg-light">
  <div class="container">
    <!-- Top Bar -->
    <div class="d-flex justify-content-end align-items-center mb-4">
      <!-- Left Links -->
      <!-- <div class="nav-links">
        <a routerLink="/privacy-policy" routerLinkActive="active-link" class="me-3 text-dark"> Privacy Policy </a>
        <a routerLink="/terms-conditions" routerLinkActive="active-link" class="text-dark"> Terms & Conditions </a>
      </div> -->

      <!-- Language Switcher -->
      <div class="btn-group">
        <button
          class="btn btn-outline-success"
          [class.active]="currentLang === 'ta'"
          (click)="switchLang('ta')"
        >
          தமிழ்
        </button>

        <button
          class="btn btn-outline-success"
          [class.active]="currentLang === 'en'"
          (click)="switchLang('en')"
        >
          English
        </button>
      </div>
    </div>
  </div>

  <!-- ---------------- Tamil Version ---------------- -->
  <div *ngIf="currentLang === 'ta'">
    <div class="card shadow-sm">
      <div class="card-body">
        <h2 class="text-center mb-4">கொள்கைகள் & விதிமுறைகள்</h2>

        <h5 class="mt-4 fw-bold">தரப்புகளின் பங்கு</h5>
        <ul>
          <li>
            <strong>Velmaral Seva Trust</strong> அனைத்து நிகழ்ச்சிகளின் ஒரே மற்றும் முழுமையான
            ஆயோஜகராக உள்ளது. நிகழ்ச்சி, பதிவு, தொடர்பு, கட்டணங்கள் மற்றும்
            பங்கேற்பாளர்கள் தொடர்பான அனைத்து பொறுப்புகளும் அவர்களுக்கே.
          </li>
          <li>
            <strong>CKTech Solution Pvt. Ltd.</strong> பதிவு செய்வதற்கான மென்பொருள் தளத்தை
            மட்டும் வழங்குகிறது; நிகழ்ச்சி மேலாண்மை, முடிவெடுத்தல் அல்லது நிதி
            தொடர்பான செயல்பாடுகளில் ஈடுபடாது.
          </li>
        </ul>

        <h5 class="mt-4 fw-bold">தளத்தின் பயன்பாடு</h5>
        <p>
          பங்கேற்பாளர் பதிவு செய்வதன் மூலம் கீழ்கண்டவற்றை ஒப்புக்கொள்கிறார்:
        </p>
        <ul>
          <li>
            நிகழ்ச்சி விவரங்கள், விதிகள், கட்டணங்கள் மற்றும் வழிமுறைகள்
            அனைத்தும் <strong>Velmaral Seva Trust</strong> மூலம் மட்டுமே வழங்கப்படுகின்றன.
          </li>
          <li>
            நிகழ்ச்சியின் தகவல் துல்லியத்திற்கும், மாற்றங்களுக்கும் <strong>CKTech</strong>
            பொறுப்பல்ல.
          </li>
        </ul>

        <h5 class="mt-4 fw-bold">கட்டணங்கள் மற்றும் பணத்தீர்</h5>
        <ul>
          <li>
            அனைத்து கட்டண பரிவர்த்தனைகளும் பங்கேற்பாளர் மற்றும் Vel Maral Seva
            Trust இடையே மட்டுமே நடைபெறும்.
          </li>
          <li>
            <strong>CKTech</strong> எந்த கட்டண முறைகளையும் நிர்வகிக்காது, சரிபார்க்காது அல்லது
            பணத்தீர்வுகளை வழங்காது.
          </li>
          <li>
            பணத்தீர் கொள்கைகள் முழுமையாக ஆயோஜகரால் தீர்மானிக்கப்படுகின்றன.
          </li>
        </ul>

        <h5 class="mt-4 fw-bold">பங்கேற்பாளர் பொறுப்புகள்</h5>
        <ul>
          <li>பதிவு செய்யும் போது சரியான தகவலை வழங்க வேண்டும்.</li>
          <li>ஆயோஜகர் அமைத்துள்ள நிகழ்ச்சி விதிகளை பின்பற்ற வேண்டும்.</li>
          <li>
            நிகழ்ச்சி தொடர்பான கேள்விகள் அல்லது பிரச்சினைகளுக்கு Vel Maral Seva
            Trust-னை தொடர்பு கொள்ள வேண்டும்.
          </li>
        </ul>

        <h5 class="mt-4 fw-bold">பொறுப்பு வரம்பு</h5>
        <ul>
          <li>
            நிகழ்ச்சி ரத்து, பங்கேற்பாளர் விவாதங்கள், கட்டண பிரச்சினைகள் அல்லது
            நிகழ்ச்சி தொடர்பான எந்த முடிவுகளுக்கும் <strong>CKTech</strong> பொறுப்பல்ல.
          </li>
          <li>
            <strong>CKTech</strong>-ன் பொறுப்பு மென்பொருள் தளம் சரியாக செயல்படுவதை
            உறுதிப்படுத்தும் அளவிற்கே வரையறுக்கப்படுகிறது.
          </li>
          <li>
            நிகழ்ச்சி அனுபவம், ஒருங்கிணைப்பு, பங்கேற்பாளர் மேலாண்மை மற்றும் சட்ட
            இணைப்புகள் முழுமையாக <strong>Velmaral Seva Trust</strong>-ன் பொறுப்பாகும்.
          </li>
        </ul>

        <h5 class="mt-4 fw-bold">அறிவுசார் собственность உரிமைகள்</h5>
        <p>
          தளத்தின் மென்பொருள் மற்றும் தொழில்நுட்ப உரிமைகள் அனைத்தும் <strong>CKTech</strong>
          Solution Pvt. Ltd.-க்கு சொந்தமானவை.
        </p>
        <p>
          நிகழ்ச்சி உள்ளடக்கங்கள் மற்றும் தகவல்கள் <strong>Velmaral Seva Trust</strong>-க்கு
          சொந்தமானவை.
        </p>

        <h5 class="mt-4 fw-bold">விதிமுறைகளில் மாற்றங்கள்</h5>
        <p>
          ஆயோஜகர் மற்றும் <strong>CKTech</strong> இருவரும் தேவைக்கேற்ப இந்த விதிமுறைகளை
          மாற்றுவதற்கு உரிமை கொண்டவர்கள். புதிய பதிப்பு ஆன்லைனில்
          வெளியிடப்படும்.
        </p>

        <!-- <h5 class="mt-4">தொடர்பு</h5>
        <p><strong>நிகழ்ச்சி மற்றும் பதிவு தொடர்பான கேள்விகள்:</strong></p>
        <p>
          <strong>Velmaral Seva Trust</strong><br />
          Email: [மின்னஞ்சல் சேர்க்கவும்]<br />
          Phone: [எண்களை சேர்க்கவும்]
        </p>

        <p><strong>தள அல்லது தொழில்நுட்ப பிரச்சினைகளுக்கு:</strong></p>
        <p>
          <strong>CKTech Solution Pvt. Ltd.</strong><br />
          Email: [மின்னஞ்சல் சேர்க்கவும்]
        </p> -->
      </div>
    </div>
  </div>

  <!-- ---------------- English Version ---------------- -->
  <div *ngIf="currentLang === 'en'">
    <div class="card shadow-sm">
      <div class="card-body">
        <h2 class="text-center fw-bold mb-4">Terms & Conditions</h2>

        <h5 class="mt-4 fw-bold">Role of the Parties</h5>
        <ul>
          <li>
            <strong>Velmaral Seva Trust</strong> is the sole organizer responsible for all
            events, registrations, communications, payments, and
            participant-related matters.
          </li>
          <li>
            <strong>CKTech Solution Pvt. Ltd.</strong> only provides the software platform for
            registration and does not participate in event operations,
            decision-making, or financial transactions.
          </li>
        </ul>

        <h5 class="mt-4 fw-bold">Use of the Platform</h5>
        <p>By completing registration, the participant agrees that:</p>
        <ul>
          <li>
            All event details, rules, fees, and instructions are provided
            exclusively by <strong>Velmaral Seva Trust</strong>.
          </li>
          <li>
            <strong>CKTech</strong> is not liable for the accuracy of event information or for
            any changes made by the Organizer.
          </li>
        </ul>

        <h5 class="mt-4 fw-bold">Payments and Refunds</h5>
        <ul>
          <li>
            All payments (if any) are handled directly between the participant
            and <strong>Velmaral Seva Trust</strong>.
          </li>
          <li>
            <strong>CKTech</strong> does not manage payment systems, verify transactions, or
            issue refunds.
          </li>
          <li>
            Refund policies are defined and controlled solely by the Organizer.
          </li>
        </ul>

        <h5 class="mt-4 fw-bold">Participant Responsibilities</h5>
        <ul>
          <li>Provide accurate information during registration</li>
          <li>Follow event rules set by the Organizer</li>
          <li>
            Contact <strong>Velmaral Seva Trust</strong> for any event-related queries or issues
          </li>
        </ul>

        <h5 class="mt-4 fw-bold">Limitation of Liability</h5>
        <ul>
          <li>
            <strong>CKTech</strong> is not responsible for event cancellations, participant
            disputes, payment issues, or any event-related outcomes.
          </li>
          <li>
            <strong>CKTech</strong>'s responsibility is limited strictly to the functioning of
            the registration software.
          </li>
          <li>
            <strong>Velmaral Seva Trust</strong> holds full responsibility for event experience,
            coordination, participant management, and compliance.
          </li>
        </ul>

        <h5 class="mt-4 fw-bold">Intellectual Property</h5>
        <p>
          All software and platform rights belong to <strong>CKTech Solution Pvt. Ltd.</strong>
        </p>
        <p>Event content and materials belong to <strong>Velmaral Seva Trust</strong>.</p>

        <h5 class="mt-4 fw-bold">Changes to Terms</h5>
        <p>
          Both the Organizer and <strong>CKTech</strong> reserve the right to modify these Terms
          at any time. The latest version will be published online.
        </p>

        <!-- <h5 class="mt-4">Contact</h5>
        <p><strong>For event and registration questions:</strong></p>
        <p>
          <strong>Velmaral Seva Trust</strong><br />
          Email: [Insert Email]<br />
          Phone: [Insert Number]
        </p>

        <p><strong>For platform or technical issues:</strong></p>
        <p>
          <strong>CKTech Solution Pvt. Ltd.</strong><br />
          Email: [Insert Email]
        </p> -->
      </div>
    </div>
  </div>
</div>
<app-cktech-footer></app-cktech-footer>